import React, { useState } from 'react';
import Modal from '../Modal';

const REASONS = [
  'Going DIY',
  'Price too high',
  'Went with a competitor',
  'No response',
  'Out of service area',
  'Quote changed after visit',
  'Other',
];

/**
 * Asks why a lead was lost. Optional - the person can skip it.
 * Rendered only while open, so its state starts fresh each time.
 */
const LostReasonModal = ({ leadName, onConfirm, onCancel }) => {
  const [reason, setReason] = useState('');
  const [otherText, setOtherText] = useState('');

  const handleConfirm = () => {
    const finalReason = reason === 'Other' && otherText.trim() ? otherText.trim() : reason;
    onConfirm(finalReason || null);
  };

  return (
    <Modal isOpen={true} onClose={onCancel} title="Mark as Lost">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Why didn't {leadName} move forward? It helps you spot patterns over time. You can skip this.
        </p>

        <div className="space-y-2">
          {REASONS.map((r) => (
            <label
              key={r}
              className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
                reason === r ? 'border-primary-600 bg-primary-100' : 'border-gray-200 hover:bg-gray-50'
              }`}
            >
              <input
                type="radio"
                name="lostReason"
                value={r}
                checked={reason === r}
                onChange={() => setReason(r)}
                className="text-primary-600 focus:ring-primary-500"
              />
              <span className="text-sm text-gray-800">{r}</span>
            </label>
          ))}
        </div>

        {reason === 'Other' && (
          <input
            type="text"
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            maxLength={100}
            placeholder="Short note (optional)"
            className="input"
          />
        )}

        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-2">
          <button type="button" onClick={onCancel} className="btn btn-secondary flex-1 justify-center">
            Cancel
          </button>
          <button type="button" onClick={handleConfirm} className="btn btn-primary flex-1 justify-center">
            Mark as Lost
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LostReasonModal;